/**
 * @generated SignedSource<<4649b230692a7aeed5234ffaae96c559>>
 * @relayHash a29381d9eac5f7393fd392464687421e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d36727361860473e99c96c154260affd2f0f3ab1d5054fa238e1e49d53aae70

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GrowthUnifiedProfileRollingDateIntervalInput = "DAYS_1" | "DAYS_180" | "DAYS_270" | "DAYS_30" | "DAYS_365" | "DAYS_7" | "DAYS_90" | "%future added value";
export type OnboardingHubPageComponentQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
  rollingIntervals: ReadonlyArray<GrowthUnifiedProfileRollingDateIntervalInput>;
  skipDelegatedAdminCheck: boolean;
  upsellEnabled: boolean;
};
export type OnboardingHubPageComponentQuery$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CustomOnboardingUpsell" | "InsightsPanel" | "OnboardingListTable">;
};
export type OnboardingHubPageComponentQuery = {
  response: OnboardingHubPageComponentQuery$data;
  variables: OnboardingHubPageComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hamsProductKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rollingIntervals"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipDelegatedAdminCheck"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "upsellEnabled"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "condition": "skipDelegatedAdminCheck",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "alias": "canManageCustomOnboarding",
          "args": [
            (v5/*: any*/),
            {
              "kind": "Literal",
              "name": "key",
              "value": "ADMINISTER"
            }
          ],
          "kind": "ScalarField",
          "name": "hasGlobalPermission"
        }
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "date"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "OnboardingHubPageComponentQuery",
    "selections": [
      {
        "condition": "upsellEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "OnboardingListTable"
          },
          {
            "kind": "FragmentSpread",
            "name": "InsightsPanel"
          }
        ]
      },
      {
        "condition": "upsellEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CustomOnboardingUpsell"
          }
        ]
      },
      (v6/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "OnboardingHubPageComponentQuery",
    "selections": [
      {
        "condition": "upsellEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/)
            ],
            "concreteType": "JiraOnboardingConfigConnection",
            "kind": "LinkedField",
            "name": "jira_onboardingConfigs",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraOnboardingConfigEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraOnboardingConfig",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "onboardingConfigAri"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "targetValues"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updatedAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDisabled"
                      },
                      {
                        "concreteType": "JiraOnboardingModal",
                        "kind": "LinkedField",
                        "name": "modals",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOnboardingStep",
                            "kind": "LinkedField",
                            "name": "steps",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraOnboardingLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_siteProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "rollingIntervals",
                    "variableName": "rollingIntervals"
                  }
                ],
                "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                "kind": "LinkedField",
                "name": "onboardingHubInsightsOverAll",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalViews"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalEngagements"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileEngagementsSeries",
                    "kind": "LinkedField",
                    "name": "engagementsSeries",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rollingInterval"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileViewSeries",
                    "kind": "LinkedField",
                    "name": "viewsSeries",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "completionRate"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileCompletionSeries",
                    "kind": "LinkedField",
                    "name": "completionsSeries",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "upsellEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "hamsProductKey",
                    "variableName": "hamsProductKey"
                  }
                ],
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "offeringName",
                                "value": "Premium"
                              }
                            ],
                            "kind": "LinkedField",
                            "name": "changeOfferingV2",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "experienceUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isAvailableToUser"
                              }
                            ],
                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "id": "0d36727361860473e99c96c154260affd2f0f3ab1d5054fa238e1e49d53aae70",
    "metadata": {},
    "name": "OnboardingHubPageComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ed7a23fe594b7647667632d65edcb5a9";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
